export default {
  "0x1": "https://etherscan.io",
};
